/** 401(k) projection with the IRS employee deferral limit. 2026 figures (IRS Notice 2025-67): $24,500; catch-up $8,000 at 50+, $11,250 at 60-63. */
export const K401_YEAR = 2026;
export const K401_LIMIT = 24500;
export const K401_CATCHUP_50 = 8000;
export const K401_CATCHUP_60_63 = 11250;

export function employeeLimit(age: number): number {
  if (age >= 60 && age <= 63) return K401_LIMIT + K401_CATCHUP_60_63;
  if (age >= 50) return K401_LIMIT + K401_CATCHUP_50;
  return K401_LIMIT;
}

export interface K401Input {
  age: number; retireAge: number; balance: number; salary: number; contribPct: number;
  matchPct: number; matchLimitPct: number; returnPct: number; raisePct: number; inflationPct: number;
}
export interface K401Row { age: number; salary: number; employee: number; employer: number; balance: number; capped: boolean }
export interface K401Result {
  rows: K401Row[]; years: number; balance: number; startBalance: number; employee: number; employer: number; growth: number;
  todaysDollars: number; cappedYears: number; firstYearEmployee: number;
}

export function project401k(i: K401Input): K401Result {
  const years = Math.max(0, Math.floor(i.retireAge - i.age));
  const r = i.returnPct / 100, raise = i.raisePct / 100, infl = i.inflationPct / 100;
  let bal = i.balance, emp = 0, er = 0, cappedYears = 0, firstYearEmployee = 0;
  const rows: K401Row[] = [];
  for (let y = 0; y < years; y++) {
    const age = i.age + y;
    const sal = i.salary * Math.pow(1 + raise, y);
    const wanted = sal * (i.contribPct / 100);
    const lim = employeeLimit(age);
    const e = Math.min(wanted, lim);
    const capped = wanted > lim;
    if (capped) cappedYears++;
    const match = Math.min(e, sal * (i.matchLimitPct / 100)) * (i.matchPct / 100);
    bal = bal * (1 + r) + e + match;
    emp += e; er += match;
    if (y === 0) firstYearEmployee = e;
    rows.push({ age, salary: sal, employee: e, employer: match, balance: bal, capped });
  }
  return { rows, years, balance: bal, startBalance: i.balance, employee: emp, employer: er, growth: bal - i.balance - emp - er, todaysDollars: bal / Math.pow(1 + infl, years), cappedYears, firstYearEmployee };
}
